var ServiceDataBase = (function () {
    function ServiceDataBase() {
    }
    return ServiceDataBase;
}());
export { ServiceDataBase };



//////////////////
// WEBPACK FOOTER
// ./src/modules/services/models/ServiceData.ts
// module id = 9NFh
// module chunks = 10